module.exports = __webpack_public_path__ + "static/media/engineering_black_24dp.769135c8.svg";